<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <!-- <form @submit.prevent="setFilter"> -->
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="row">
          <div class="col">
            <form @submit.prevent="applyFilter">
              <a-input :placeholder="placeholder" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="member_name"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                  style="width: 110px"
                >
                  <a-select-option value="member_name"> Name </a-select-option>
                  <a-select-option value="membership_number">
                    Member ID
                  </a-select-option>
                  <a-select-option value="card_number">
                    Card Number
                  </a-select-option>
                </a-select>
              </a-input>

              <small
                ><i>
                  <small>{{ example }}</small></i
                ></small
              >
            </form>
          </div>
        </div>
        <hr />

        <form role="form" @submit.prevent>
          <div>
            <div>
              <label>Membership Program</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.membership_program_ids"
                  style="width: 100%"
                  placeholder="Select Membership Program"
                >
                  <a-select-option :value="null">All</a-select-option>
                  <a-select-option
                    v-for="membershipProgram in options.membershipPrograms"
                    :value="membershipProgram.id"
                    :key="membershipProgram.id"
                    :label="membershipProgram.name"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Bulk Adjustment ID</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.bulk_adjustment_batch_id"
                  style="width: 100%"
                  placeholder="Select Bulk Adjustment Batch ID"
                >
                  <a-select-option :value="null">All</a-select-option>
                  <a-select-option
                    v-for="batchId in options.batchIds"
                    :value="batchId.upload_batch_code"
                    :key="batchId.upload_batch_code"
                    :label="batchId.upload_batch_code"
                  >
                    {{ batchId.upload_batch_code }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Transaction Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.transaction_type_id"
                  style="width: 100%"
                  placeholder="Select Transaction Type"
                >
                  <a-select-option :value="null">All</a-select-option>
                  <a-select-option
                    v-for="transactionType in options.transactionTypes"
                    :value="transactionType.id"
                    :key="transactionType.id"
                    :label="transactionType.name"
                  >
                    {{ transactionType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Date</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <base-input>
                  <a-range-picker
                    :default-value="null"
                    :format="dateFormat"
                    @change="dateRangeOnChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
        <!-- </form> -->
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              v-if="selectedActions.includes('Add')"
              @click="openDrawer()"
              >Add Entry</base-button
            >
            <base-button
              class="float-right ml-1 btn btn-danger"
              size="sm"
              type="danger"
              v-if="selectedActions.includes('Bulk Adjustment')"
              @click="openBulkDrawer()"
              >Add Bulk</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <PointsAdjustmentForm
                :viewMode="viewMode"
                :pointsAdjustmentData="pointsAdjustmentData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
            <a-drawer
              :width="bulkDrawer.width"
              :placement="bulkDrawer.placement"
              :visible="bulkDrawer.visible"
              @close="closeBulkDrawer"
            >
              <BulkPointsAdjustmentForm
                :viewMode="viewMode"
                :pointsAdjustmentData="pointsAdjustmentData"
                @closeDrawer="closeBulkDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              class="btn btn-success btn-sm"
              v-if="selectedActions.includes('View')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
          </template>

          <template #customComponent="{ tableProps }">
            <span>{{
              tableProps.rowData.member.first_name +
              ' ' +
              tableProps.rowData.member.last_name
            }}</span>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import PointsAdjustmentForm from './PointsAdjustmentForm.vue';
import BulkPointsAdjustmentForm from './BulkPointsAdjustmentForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import moment from 'moment';
import { mapGetters } from 'vuex';

const ENV = process.env.VUE_APP_ENV;

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    PointsAdjustmentForm,
    BulkPointsAdjustmentForm
  },
  data() {
    return {
      // selectedActions: [],
      gradientType: 'gradient-green',
      pointsAdjustmentData: null,
      dateFormat: 'YYYY-MM-DD',
      search: '',
      example: 'First Name / Last Name (e.g. John / Doe)',
      placeholder: 'First Name / Last Name',
      searchType: 'member_name',
      bulkDrawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      drawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Points Adjustment Transactions',
        apiUrl: '/api/v1/clp_transactions/points_adjustments',
        fields: [
          'actions',
          { name: 'member.membership_number', title: 'Member ID' },
          { name: 'custom-slot', title: 'Member Name' },
          { name: 'card_number', title: 'Card Number' },
          { name: 'transactionType.name', title: 'Transaction Type' },
          { name: 'adjustmentReasonType.name', title: 'Reason Type' },
          { name: 'upload_batch_code', title: 'Batch ID' },
          {
            name: 'created_at',
            title: 'Date',
            formatter(date) {
              if (moment(date).isValid()) {
                if (ENV === 'development') {
                  return moment(date).format('MM/DD/YYYY');
                } else {
                  return moment.utc(date).format('MM/DD/YYYY');
                }
              }
              return null;
            }
          },
          { name: 'points', title: 'Points' },
          { name: 'user_name', title: 'Created By' },
          'remarks'
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        filters: {
          filter: false,
          status_code: null,
          member_name: null,
          first_name: null,
          last_name: null,
          membership_program_ids: null,
          membership_number: null,
          card_number: null,
          transaction_type_id: null,
          transaction_date_from: null,
          transaction_date_to: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      },

      options: {
        transactionTypes: [],
        batchIds: [],
        membershipPrograms: []
      }
    };
  },
  methods: {
    searchTypeOnChange() {
      this.table.filters = {
        status_code: null,
        member_name: null,
        membership_number: null,
        card_number: null,
        transaction_type_id: null,
        transaction_date_from: null,
        transaction_date_to: null
      };
      switch (this.searchType) {
        case 'member_name':
          this.placeholder = 'First Name / Last Name';
          this.example = 'First Name / Last Name (e.g. John / Doe)';
          break;
        case 'membership_number':
          this.placeholder = 'Member ID';
          this.example = 'Member ID (e.g. 123456)';
          break;
        case 'card_number':
          this.placeholder = 'Card Number';
          this.example = 'Card Number (e.g. 100000234567)';
          break;
      }
      this.table.filters.filter = true;
      this.table.filters[this.searchType] = this.search;
    },
    openBulkDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.pointsAdjustmentData = rowData;
      this.bulkDrawer.visible = true;
    },

    closeBulkDrawer() {
      this.bulkDrawer.visible = false;
      this.pointsAdjustmentData = null;
      this.getBatchIds();
    },
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.pointsAdjustmentData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.pointsAdjustmentData = null;
    },

    applyFilter() {
      if (this.searchType == 'member_name' && this.search) {
        const search = this.search.split('/');
        this.table.filters[this.searchType] = null;
        typeof search[0] != 'undefined'
          ? (this.table.filters['first_name'] = search[0].trim())
          : '';
        typeof search[1] != 'undefined'
          ? (this.table.filters['last_name'] = search[1].trim())
          : '';
      }
      if (
        this.table.filters['status_code'] == null &&
        this.table.filters['first_name'] == null &&
        this.table.filters['last_name'] == null &&
        this.table.filters['card_number'] == null &&
        this.table.filters['member_name'] == null &&
        this.table.filters['membership_number'] == null &&
        this.table.filters['membership_program_ids'] == null &&
        this.table.filters['mobile_no'] == null &&
        this.table.filters['transaction_type_id'] == null &&
        this.table.filters['transaction_date_from'] == null &&
        this.table.filters['transaction_date_to'] == null
      ) {
        this.table.filters.filter = false;
      } else {
        this.table.filters.filter = true;
      }
      this.setFilter();
    },
    setFilter() {
      this.$root.$emit('refreshTable');
    },

    dateRangeOnChange(dateObj, dateString) {
      this.table.filters.transaction_date_from = dateString[0];
      this.table.filters.transaction_date_to = dateString[1];
      this.table.filters.filter = true;
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs',
        { per_page: 1000 }
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async getTransactionTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_transaction_types?manual_flag=1'
      );
      this.options.transactionTypes = response.data;
    },
    async getBatchIds() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_transactions/filter/batch_id'
      );
      this.options.batchIds = response;
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  created() {
    this.getBatchIds();
    this.getMembershipPrograms();
    this.getTransactionTypes();
    this.$store.dispatch('setCurrentModule', 'PointsAdjustment');
  },

  mounted() {
    // this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  watch: {
    search(val) {
      this.table.filters.filter = true;
      this.table.filters[this.searchType] = val;
    },
    'table.filters.transaction_date_from': function (val) {
      if (val == '') {
        this.table.filters.filter = true;
        this.table.filters.transaction_date_from = null;
      }
    },

    'table.filters.transaction_date_to': function (val) {
      if (val == '') {
        this.table.filters.filter = true;
        this.table.filters.transaction_date_to = null;
      }
    }
  }
};
</script>

<style scoped></style>
